var _rect, _rect2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 12,
    fill: "url(#paint0_radial_3475_31637)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 11.5,
    stroke: "white",
    strokeOpacity: 0.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3475_31637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.603 9.5H25.397C26.7402 9.5 27.9899 10.1875 28.709 11.322L33.16 18.3451C33.9341 19.5665 33.9731 21.1148 33.2616 22.3736L28.6633 30.5084C27.9677 31.7391 26.6635 32.5 25.2498 32.5H16.7502C15.3365 32.5 14.0323 31.7391 13.3367 30.5084L8.73842 22.3736C8.02686 21.1148 8.06588 19.5665 8.83997 18.3451L13.291 11.322C14.0101 10.1875 15.2598 9.5 16.603 9.5Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0808 17.3989L15.0449 19.4654C14.6791 19.8368 14.8951 20.4664 15.4119 20.5348L20.7621 21.2431C21.0762 21.2847 21.3108 21.5525 21.3108 21.8693V26.7222C21.3108 27.2871 21.9958 27.5679 22.3923 27.1654L24.8625 24.6581C24.9789 24.5399 25.0442 24.3807 25.0442 24.2148V22.8099C25.0442 22.6608 25.097 22.5164 25.1932 22.4025L26.7618 20.5449C26.858 20.4309 26.9108 20.2866 26.9108 20.1374V15.6316C26.9108 15.2828 26.6281 15 26.2793 15H22.1974C22.0283 15 21.8662 15.0678 21.7475 15.1883L19.9408 17.0222C19.8221 17.1427 19.66 17.2105 19.4909 17.2105H17.5308C17.3616 17.2105 17.1995 17.2784 17.0808 17.3989Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.631579
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9222 24.0368L15.5489 25.9316C15.472 26.3219 15.7707 26.6852 16.1686 26.6852H17.9922C18.294 26.6852 18.5536 26.4718 18.6119 26.1758L18.9852 24.281C19.0621 23.8907 18.7634 23.5273 18.3656 23.5273H16.5419C16.2402 23.5273 15.9806 23.7408 15.9222 24.0368Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.631579
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3475_31637)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 37.5,
    y1: 21,
    x2: 37.5,
    y2: 26,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 23.5,
    x2: 40,
    y2: 23.5,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 8,
    x2: 11.5,
    y2: 13,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10.5,
    x2: 14,
    y2: 10.5,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7002,
    y1: 34,
    x2: 10.7002,
    y2: 37,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 35.3008,
    x2: 12,
    y2: 35.3008,
    stroke: "white",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 9.5,
    x2: 36,
    y2: 9.5,
    stroke: "white",
    strokeOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3475_31637",
    x: -10,
    y: -8,
    width: 62,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.72 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3475_31637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3475_31637",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3475_31637",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.085 -83) rotate(87.4648) scale(180.677 84.5178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0432605,
    stopColor: "#81DDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3F5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C316E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3475_31637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    fill: "white",
    transform: "translate(9 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlan);
export default __webpack_public_path__ + "static/media/upgrade-plan.81f1429d761c399a380aef08b4a21dc3.svg";
export { ForwardRef as ReactComponent };